export interface CourseEvent {
  id: string;
  date: number;
  title: string;
  type: "zoom-qa" | "offline-field" | "deadline";
  time?: string;
  courseTitle?: string;
  courseId?: string;
}

export const courseEvents: CourseEvent[] = [
  {
    id: "evt-1",
    date: 3,
    title: "경매 입문 클래스 개강",
    type: "deadline",
    time: "모집마감",
    courseTitle: "경매 입문 클래스",
    courseId: "1",
  },
  {
    id: "evt-2",
    date: 7,
    title: "Zoom 라이브 Q&A - 권리분석 특집",
    type: "zoom-qa",
    time: "20:00",
  },
  {
    id: "evt-3",
    date: 10,
    title: "권리분석 마스터 과정 개강",
    type: "deadline",
    time: "모집마감",
    courseTitle: "권리분석 마스터 과정",
    courseId: "2",
  },
  {
    id: "evt-4",
    date: 14,
    title: "오프라인 현장 임장 - 서울북부지원",
    type: "offline-field",
    time: "10:00",
  },
  {
    id: "evt-5",
    date: 18,
    title: "Zoom 라이브 Q&A - 입찰 전략 특집",
    type: "zoom-qa",
    time: "20:00",
  },
  {
    id: "evt-6",
    date: 21,
    title: "명도실무 완전정복 개강",
    type: "deadline",
    time: "모집마감",
    courseTitle: "명도실무 완전정복",
    courseId: "4",
  },
  {
    id: "evt-7",
    date: 24,
    title: "오프라인 현장 임장 - 서울중앙지법",
    type: "offline-field",
    time: "10:00",
  },
  {
    id: "evt-8",
    date: 28,
    title: "Zoom 라이브 Q&A - 명도실무 특집",
    type: "zoom-qa",
    time: "20:00",
  },
];